var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 12C24.6117 5.3725 19.2227 0 12.5749 0C5.92723 0 0.538086 5.3725 0.538086 12C0.538086 18.6275 5.92723 24 12.5749 24C19.2227 24 24.6117 18.6275 24.6117 12Z",
    fill: "#C83C3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 2.55469C21.6054 4.59375 22.5628 7.164 22.5628 9.95728C22.5628 16.5846 17.1737 21.9573 10.526 21.9573C7.72408 21.9573 5.14606 21.0027 3.10059 19.4024C5.30423 22.2015 8.72891 23.9998 12.5748 23.9998C19.2227 23.9998 24.6116 18.6273 24.6116 11.9998C24.6116 8.16559 22.8079 4.7514 20.0002 2.55469Z",
    fill: "#ECCBCD",
    fillOpacity: 0.139915
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3357 14.0165H11.8069C11.5042 14.0165 11.2588 13.7719 11.2588 13.47V6.57001C11.2588 6.26807 11.5042 6.02344 11.8069 6.02344H13.3357C13.6384 6.02344 13.884 6.26807 13.884 6.57001V13.47C13.884 13.7719 13.6386 14.0165 13.3357 14.0165Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5713 18.3673C11.8464 18.3673 11.2588 17.7814 11.2588 17.0588V17.0585C11.2588 16.3359 11.8464 15.75 12.5713 15.75C13.2962 15.75 13.884 16.3359 13.884 17.0585V17.0588C13.884 17.7814 13.2962 18.3673 12.5713 18.3673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningExclamationIcon);
export default __webpack_public_path__ + "static/media/warning-exclamation-icon.196d9ff309b189eec9dd845f6a4f2ab1.svg";
export { ForwardRef as ReactComponent };